import { getTasksUrl } from "../config/Config";
import { getRequest, postRequest } from "./ServiceHelper";

export const TaskTitle = { collectEvidence: "collect evidence" };

export class TaskService {
  static createTask = (obj) => {
    return postRequest(getTasksUrl(), obj);
  };

  static getTaskById = (taskId) => {
    return getRequest(getTasksUrl() + "/" + taskId);
  };
}
